export type PackagingExportKind = 'suppliers' | 'packed-items' | 'packaging-items'

type BuildPackagingExportFilenameInput = {
  date: Date
  organizationName?: string | null
  kind: PackagingExportKind
}

const EXPORT_FILENAME_SUFFIX: Record<PackagingExportKind, string> = {
  suppliers: 'SUPPLIERS_STATUS',
  'packed-items': 'PACKED_ITEMS_STATUS',
  'packaging-items': 'PACKAGING_ITEMS_STATUS',
}

const ILLEGAL_FILENAME_CHARACTERS = /[/\\:*?"<>|]/g

function formatExportDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function sanitizeOrganizationNameForFilename(name: string): string {
  return name
    .trim()
    .replace(ILLEGAL_FILENAME_CHARACTERS, '')
    .replace(/\s+/g, '_')
    .toUpperCase()
}

export function buildPackagingExportFilename({
  date,
  organizationName,
  kind,
}: BuildPackagingExportFilenameInput): string {
  const datePart = formatExportDate(date)
  const suffix = EXPORT_FILENAME_SUFFIX[kind]
  const sanitizedOrganizationName =
    organizationName == null || organizationName.trim() === ''
      ? ''
      : sanitizeOrganizationNameForFilename(organizationName)

  if (sanitizedOrganizationName === '') {
    return `${datePart}_${suffix}.xlsx`
  }

  return `${datePart}_${sanitizedOrganizationName}_${suffix}.xlsx`
}
